import { c as _c } from "react/compiler-runtime";
import React from "react";
import CircleLoader, { CircleLoaderSize } from "@/components/distribution-plan-tool/common/CircleLoader";
interface WaveDropsScrollingOverlayProps {
  readonly isVisible: boolean;
}
export default function WaveDropsScrollingOverlay(t0) {
  const $ = _c(2);
  const {
    isVisible
  } = t0;
  if (!isVisible) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="tw-absolute tw-inset-0 tw-bg-iron-900 tw-bg-opacity-50 tw-z-10" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <>{t1}<div className="tw-absolute tw-inset-0 tw-flex tw-flex-col tw-items-center tw-justify-center tw-z-20"><div className="tw-rounded-full tw-p-4"><CircleLoader size={CircleLoaderSize.XXLARGE} /></div></div></>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  return t2;
}